import { LOGO_PATH_LIGHT, LOGO_PATH_DARK } from '../lib/branding';

/**
 * Worksnip wordmark — renders an extracted-path SVG (not a font-dependent
 * double-render). The tokenized SVG uses var(--ws-ink) + var(--ws-accent)
 * with hex fallbacks so it adapts to whichever theme is active AND
 * rasterizes correctly in non-CSS contexts (canvas, server-rendered HTML).
 *
 * Aspect ratio is ~5.4:1 — set `size` to the desired height; width auto-
 * scales. The on-dark variant uses white + coral and is appropriate for
 * dark CTA bands / footer / any white-on-dark surface.
 *
 * Asset paths are NOT hardcoded here — they live in `lib/branding.ts` so
 * the canvas export pipeline and any future surface can share them.
 * Swap the SVGs in `/public/logo/` to update the whole app at once.
 *
 * See docs/BLUEPRINTS/10-ui-ux/05-new-ui-theme.md §3.
 */
type Props = {
  /** Pixel height of the wordmark; width auto-scales to ~5.4× height. */
  size?: number;
  /** Use the on-dark variant (white wordmark + coral K). */
  onDark?: boolean;
  className?: string;
};

export function Wordmark({ size = 22, onDark = false, className }: Props) {
  const src = onDark ? LOGO_PATH_DARK : LOGO_PATH_LIGHT;
  return (
    <img
      src={src}
      alt="worksnip"
      height={size}
      className={className}
      style={{ height: size, width: 'auto', display: 'block' }}
    />
  );
}
